import sideBar from './sideBar.vue'
export default sideBar



// WEBPACK FOOTER //
// ./src/layout/sideBar/index.js